export const POLICYSTREAM_URL_PREFIX = '/insurance';

const makeFullUrl = (baseUrl: string) => {
  return (slug: string) => `${baseUrl}/${slug}`;
};
export const makePolicystreamUrl = makeFullUrl(POLICYSTREAM_URL_PREFIX);

const POLICYSTREAM_PAGES = [
  'welcome',
  'baseInformation',
  'personalize',
  'recommendations',
  'planSelection',
  'postPlanSelectionInformation',
  'contactInfo',
  'planSpecificQuestions',
  'done',
  'resume',
  'review',
  'emailSave',
  'tos',
  'demo',
] as const;
export type PolicyStreamPage = typeof POLICYSTREAM_PAGES[number];

export const WELCOME_PAGE_SLUG = '';
export const WELCOME_PAGE_URL = makePolicystreamUrl(WELCOME_PAGE_SLUG);

export const BASE_INFO_PAGE_SLUG = 'basicinformation';
export const BASE_INFO_PAGE_URL = makePolicystreamUrl(BASE_INFO_PAGE_SLUG);

export const QUIZ_PAGE_SLUG = 'personalize';
export const QUIZ_PAGE_URL = makePolicystreamUrl(QUIZ_PAGE_SLUG);

export const PLAN_SELECTION_PAGE_SLUG = 'planselection';
export const PLAN_SELECTION_PAGE_URL = makePolicystreamUrl(
  PLAN_SELECTION_PAGE_SLUG,
);

export const CONTACT_INFO_PAGE_SLUG = 'contact';
export const CONTACT_INFO_PAGE_URL = makePolicystreamUrl(
  CONTACT_INFO_PAGE_SLUG,
);

export const PLAN_SPECIFIC_QUESTIONS_PAGE_SLUG = 'questions';
export const PLAN_SPECIFIC_QUESTIONS_URL = makePolicystreamUrl(
  PLAN_SPECIFIC_QUESTIONS_PAGE_SLUG,
);

export const POST_PLAN_SELECTION_INFORMATION_PAGE_SLUG =
  'additionalinformation';
export const POST_PLAN_SELECTION_INFORMATION_PAGE_URL = makePolicystreamUrl(
  POST_PLAN_SELECTION_INFORMATION_PAGE_SLUG,
);

export const DONE_PAGE_SLUG = 'done';
export const DONE_PAGE_URL = makePolicystreamUrl(DONE_PAGE_SLUG);

export const RESUME_PAGE_SLUG = 'resume';
export const RESUME_PAGE_URL = makePolicystreamUrl(RESUME_PAGE_SLUG);

export const RECOMMENDATIONS_PAGE_SLUG = 'recommendations';
export const RECOMMENDATIONS_PAGE_URL = makePolicystreamUrl(
  RECOMMENDATIONS_PAGE_SLUG,
);

const EMAIL_SAVE_PAGE_SLUG = 'save_application';
export const EMAIL_SAVE_PAGE_URL = makePolicystreamUrl(EMAIL_SAVE_PAGE_SLUG);

const REVIEW_PAGE_SLUG = 'review';
export const REVIEW_PAGE_URL = makePolicystreamUrl(REVIEW_PAGE_SLUG);

const TOS_PAGE_SLUG = 'tos';
const TOS_PAGE_URL = makePolicystreamUrl(TOS_PAGE_SLUG);

const DEMO_PAGE_SLUG = 'demo';
const DEMO_PAGE_URL = makePolicystreamUrl(DEMO_PAGE_SLUG);

export const policyStreamPaths: Record<
  PolicyStreamPage,
  { slug: string; url: string }
> = {
  welcome: { slug: WELCOME_PAGE_SLUG, url: WELCOME_PAGE_URL },
  baseInformation: { slug: BASE_INFO_PAGE_SLUG, url: BASE_INFO_PAGE_URL },
  personalize: { slug: QUIZ_PAGE_SLUG, url: QUIZ_PAGE_URL },
  recommendations: {
    slug: RECOMMENDATIONS_PAGE_SLUG,
    url: RECOMMENDATIONS_PAGE_URL,
  },
  emailSave: { slug: EMAIL_SAVE_PAGE_SLUG, url: EMAIL_SAVE_PAGE_URL },
  planSelection: {
    slug: PLAN_SELECTION_PAGE_SLUG,
    url: PLAN_SELECTION_PAGE_URL,
  },
  postPlanSelectionInformation: {
    slug: POST_PLAN_SELECTION_INFORMATION_PAGE_SLUG,
    url: POST_PLAN_SELECTION_INFORMATION_PAGE_URL,
  },
  contactInfo: { slug: CONTACT_INFO_PAGE_SLUG, url: CONTACT_INFO_PAGE_URL },
  planSpecificQuestions: {
    slug: PLAN_SPECIFIC_QUESTIONS_PAGE_SLUG,
    url: PLAN_SPECIFIC_QUESTIONS_URL,
  },
  review: { slug: REVIEW_PAGE_SLUG, url: REVIEW_PAGE_URL },
  done: { slug: DONE_PAGE_SLUG, url: DONE_PAGE_URL },
  resume: {
    slug: RESUME_PAGE_SLUG,
    url: RESUME_PAGE_URL,
  },
  tos: { slug: TOS_PAGE_SLUG, url: TOS_PAGE_URL },
  demo: { slug: DEMO_PAGE_SLUG, url: DEMO_PAGE_URL },
} as const;
